import { Tooltip } from "@mui/material";
import React, {
  memo,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { StyledTypography } from "../../common/Utils/StyledComponents";

const TextWrapWithTooltip = ({
  label,
  customClassName = "maxwidth-350",
  customStyle = {},
  textVariant = "h6",
  role,
  hasPinned = false,
  hasFlagged = false,
  isSelfAssignedList = false,
  riskFactor,
}) => {
  const textElementRef = useRef(null);
  const [isOverflown, setIsOverflown] = useState(false);

  const overflowCheck = () => {
    const element = textElementRef.current;

    if (element) {
      const compare =
        element.offsetWidth < element.scrollWidth ||
        element.offsetHeight < element.scrollHeight;
      setIsOverflown(compare);
    }
  };

  useEffect(() => {
    // Initial check to set initial overflow state after label update
    overflowCheck();
  }, [label]);

  useLayoutEffect(() => {
    // Initial check to set initial overflow state
    overflowCheck();

    setTimeout(() => overflowCheck(), 100);

    // Add event listener for window resize
    window.addEventListener("resize", overflowCheck);

    return () => {
      // Remove event listener on unmount
      window.removeEventListener("resize", overflowCheck);
    };
  }, []);

  return (
    <>
      {isOverflown ? (
        <StyledTypography
          variant={textVariant}
          className="commentSectionIcon pr-0"
        >
          <StyledTypography
            ref={textElementRef}
            variant={textVariant}
            className={`ellipsisStyle ${customClassName}`}
            sx={{ ...customStyle }}
            data-toggle="tooltip"
            title={label}
          >
            {`${label} `}
          </StyledTypography>
          {hasFlagged && <span className={`iconFlagColorStyle fa fa-flag-o`} />}
          {hasPinned && (
            <span className={`iconPinColorStyle fa fa-thumb-tack`} />
          )}
          {role && (
            <StyledTypography
              ref={textElementRef}
              variant={textVariant}
              sx={{ minWidth: "105px", ...customStyle }}
              data-toggle="tooltip"
              title={role}
            >
              | {role}
            </StyledTypography>
          )}
        </StyledTypography>
      ) : (
        <StyledTypography
          variant={textVariant}
          className="commentSectionIcon  pr-0 w-100"
        >
          <Tooltip title={label}>
            <StyledTypography
              ref={textElementRef}
              variant={textVariant}
              className={`ellipsisStyle ${customClassName}`}
              sx={{
                ...customStyle,
              }}
              data-toggle="tooltip"
              title={role ? label : ""}
            >
              {`${label} `}
            </StyledTypography>
          </Tooltip>
          {isSelfAssignedList && riskFactor && (
            // <Icon
            //   icon="tabler:alert-triangle"
            //   width="17"
            //   height="17"
            //   style={{ flexShrink: 0 }}
            //   color={
            //     riskFactor === "LOW"
            //       ? "#F4BD34"
            //       : riskFactor === "MEDIUM"
            //         ? "#FFA24C"
            //         : "#EE4047"
            //   }
            // />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 30 30"
            >
              <path
                fill="none"
                stroke={
                  riskFactor === "LOW"
                    ? "#F4BD34"
                    : riskFactor === "MEDIUM"
                    ? "#FFA24C"
                    : "#EE4047"
                }
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v4m-1.637-9.409L2.257 17.125a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636-2.87L13.637 3.59a1.914 1.914 0 0 0-3.274 0zM12 16h.01"
              />
            </svg>
          )}
          {hasFlagged && (
            <span className={`iconFlagColorStyle fa fa-flag-o mx-1`} />
          )}
          {hasPinned && (
            <span className={`iconPinColorStyle fa fa-thumb-tack ml-1`} />
          )}

          {role && (
            <StyledTypography
              ref={textElementRef}
              variant={textVariant}
              sx={{ marginLeft: "5px", minWidth: "105px", ...customStyle }}
            >
              | {role}
            </StyledTypography>
          )}
        </StyledTypography>
      )}
    </>
  );
};

export default memo(TextWrapWithTooltip);
